module.exports = __webpack_public_path__ + "static/media/awad1.72cfd6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/awad1.png
// module id = 1308
// module chunks = 0